module.exports = __webpack_public_path__ + "img/error_wrong.3be1569e.svg";